import { formatDayMonth, formatDayMonthTime, formatTime } from '../../utils/format';

const DAY = 24 * 60 * 60 * 1000;

/** Five evenly spaced x-axis labels for buckets starting at `starts`, last label at the window's end. */
export const axisLabels = (starts: Date[], to: Date, spanMs: number): string[] => {
  if (!starts.length) return [];
  const fmt = spanMs <= DAY ? formatTime : formatDayMonth;
  const n = starts.length;
  return [0, 0.25, 0.5, 0.75].map((f) => fmt(starts[Math.round(f * (n - 1))])).concat(fmt(to));
};

export const pointLabels = (starts: Date[], spanMs: number) =>
  starts.map((d) => (spanMs <= DAY ? formatTime(d) : formatDayMonthTime(d)));

export const bucketLabel = (bucketMs: number) => {
  const minutes = bucketMs / 60000;
  return minutes < 60 ? `${minutes} min` : `${minutes / 60} h`;
};
